<template>
    <b-modal id="defaultModalStatus" hide-footer centered>
        <UpdateStatus v-if="action.action === 'updateStatus'" :action="action"> </UpdateStatus>

        <UpdateArchive v-if="action.action === 'updateArchive'" :action="action"> </UpdateArchive>
    </b-modal>
</template>

<script>
import UpdateStatus from "../actions/UpdateStatus";
import UpdateArchive from "../actions/UpdateArchive";

export default {
    props: ["action"],
    data() {
        return {};
    },
    components: {
        UpdateStatus,
        UpdateArchive
    },
    watch: {},
    mounted() {},
    methods: {},
    computed: {},
    created() {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Modal.vue?6be1d65a